import { Navigate, Route, Routes } from 'react-router-dom';
import ManageCaisse from './Qm/ManageCaisse';
import GestionGroup from './UserGroup/GestionGroup';
import GestionEntite from './Entites/GestionEntite';
import GestionServices from './Services/GestionServices';
import GestionUser from './UserGroup/GestionUser';
import GestionPriorite from './Config/GestionPriorite';
import GestionParametres from './Config/GestionParametres';
import GestionCreneaux from './Config/GestionCreneaux';
import GestionOperations from './Config/GestionOperations';
import GestionFormulaires from './Config/GestionFormulaires';
import GestionLayouts from './Config/GestionLayouts';
import GestionClients from './Clients/GestionClients';
import GestionDocuments from './Documents/GestionDocuments';
import GestionBI from './Config/GestionBI';
import GestionBornes from './Config/GestionBornes';
import GestionAnnonces from './Config/GestionAnnonces';

/**
 * Contenu de la page /setting.
 * L'accueil affiche les paramètres de la plateforme ; les autres pages
 * d'administration sont accessibles depuis le sidebar.
 */
const ContenuSetting = () => {
    return (
        <div className='containerAA'>
            <Routes>
                <Route path="/" element={<GestionParametres />} />
                <Route path="/parametres" element={<GestionParametres />} />

                <Route path="/manageCaisse" element={<ManageCaisse />} />
                <Route path="/manageUser" element={<GestionUser />} />
                <Route path="/manageGroup" element={<GestionGroup />} />
                <Route path="/text&message" element={<Navigate to="/setting/parametres" replace />} />

                <Route path="/entites" element={<GestionEntite />} />
                <Route path="/services" element={<GestionServices />} />

                <Route path="/priorite" element={<GestionPriorite />} />
                <Route path="/creneaux" element={<GestionCreneaux />} />
                <Route path="/operations" element={<GestionOperations />} />
                <Route path="/formulaires" element={<GestionFormulaires />} />
                <Route path="/layouts" element={<GestionLayouts />} />
                <Route path="/clients" element={<GestionClients />} />
                <Route path="/documents" element={<GestionDocuments />} />
                <Route path="/bi" element={<GestionBI />} />
                <Route path="/annonces" element={<GestionAnnonces />} />
                <Route path="/manageBorne" element={<GestionBornes />} />
            </Routes>
        </div>
    );
};

export default ContenuSetting
